
import React from "react";
import "react-bootstrap-typeahead/css/Typeahead.css";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { getFileDetailsByfileName, getFileTimeLine, reintiateParkedFile } from "../../actions/FileAction";
import Header from "../../component/common/Header";
import Loader from "../../component/common/Loader";
import { setValue } from "../../utils";
import './../../assets/css/styling.css';

import TextEditor from "../../component/common/TextEditor";

import CONSTANT from "../../constant";
 
import moment from "moment";
import {
  checkFileNumber,
  getFileListDeptWise
} from "../../actions/FileAction";
import { getDepartmentList } from "../../actions/MasterAction";
import { getApprovingAuthority } from "../../actions/UserAction";
import { autoSave } from "../../actions/eDraftAction";
import constant from "../../constant";
import {
  getCookie,
  getStorage,
  onArrayChange,
  onChange,
  setOptions,
  setStorage
} from "../../utils";

 

 class IntitateParkedFile extends React.Component<any, any> {
  
  // userProposal: any;
  // clrInterval: any;

  constructor(props: any) {
    super(props);

    const recipients = getStorage(CONSTANT.cookie.recipients);
    const todaysDate = new Date().toISOString().split("T")[0];
    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    const proposal = getStorage("propsal");
    const proposalValue = proposal ? proposal : "";
    this.state = {
   // new 
      fileCode :props.match.params.fileCode , 
       timeLine:[],
   // new
      fileDetails:undefined ,
       fileNumber: {
        name: "fileNumber",
        value:`${constant.organisation.name}/${userDetail.unitName}/${userDetail.departmentName}/`,
        error: "",
        isRequired: true,
      },
       
      dated: { name: "dated" , value: todaysDate , error: "" , isRequired: true  },
      subject: { name: "subject", value: "", error: "", isRequired: true },
      financialImplication: {
        name: "financialImplication",
        value: "",
        error: "",
        isRequired: true,
      },
      approvingAuthority: {
        name: "approvingAuthority",
        value: "",
        error: "",
        isRequired: true,
        options: [],
      },
      body: { name: "body", value: proposalValue, error: "", isRequired: true },
       to: {
        name: "to",
        value: [],
        options: recipients,
        error: "",
        isRequired: true,
      },
      attachments: {
        name: "attachments",
        value: [],
        filteredFile:undefined,
        error: "",
        isRequired: true,
      },
      department: {
        name: "department",
        value: [],
        error: "",
        isRequired: false,
        options: [],
      },
      referenceFilesDept: {
        name: "referenceFilesDept",
        value: [],
        error: "",
        isRequired: false,
        options: [],
      },
      referenceFiles: {
        name: "referenceFiles",
        value: [],
        error: "",
        isRequired: false,
        options: [],
      },
      showLoader: false,
      isFileNumberValid: undefined,
      userDetail,
      commentedReviewers: [],
    };
  
      this.handleClick = this.handleClick.bind(this);
       
    }

  handleClick(index:any) {
      alert(index)
  }

  componentDidMount() {
     
    const { fileCode ,fileDetails ,subject , financialImplication ,body ,dated   }  = this.state
    window.scrollTo(0, 0);
     
    document.title = CONSTANT.pageTitle.fileDetail;

     getDepartmentList().then((res: any) => {
      setOptions(this, this.state.department.name, res.result);
      setOptions(this, "referenceFilesDept", res.result);
    });
     
     
    getApprovingAuthority().then((res: any) => {
      setOptions(this, this.state.approvingAuthority.name, res.result);
    });

     
    getFileTimeLine(fileCode).then((res:any)=>{
         if(res.status===constant.static.apiStatus.success) {
                 this.setState({...this.state , timeLine :res.result })   
           }
    }).catch((err:any)=>{
       
    })


    getFileDetailsByfileName(fileCode).then((res:any)=>{
     if(res.status===constant.static.apiStatus.success) {
             this.setState({...this.state , fileDetails :res.result   } ,
               ()=>{
              this.setState({ ...this.state , subject: { ...subject , value : res.result.subject  } ,body:{...body , value:res.result.body }   ,financialImplication: { ...financialImplication , value:res.result.  financialImplication} ,  dated:{...dated , value: moment(res.result.dated).format('YYYY-MM-DD')  } })
             } )   
         }
}).catch((err:any)=>{
   
})


  }


  componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {


  }



  render() {
    const {
      isFileNumberValid,
      fileNumber,
      dated,
      subject,
      body,
      to,
      attachments,
      department,
      financialImplication,
      approvingAuthority,
      referenceFilesDept,
      referenceFiles,
    } = this.state;

   const dltFile = this

    const { showLoader } = this.state;

    return (

      <div className="container-fluid">

        <div className="row">
          {/* <div className="col-md-2 px-0">
            <Header />
          </div> */}
          <div className="col-md-12">
            <div className="row my-3">
              <div className="col-md-8">
                <h1 className="page-title">Re-intiate File Details</h1>
              </div>
              <div className="col-md-4">
                <Link
                  to={CONSTANT.component.userFileList.url}
                  className="btn btn-sm btn-link float-right"
                >
                  Go Back
                </Link>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={this.onSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            
                             <label>
                              File # <small className="text-danger">*</small>
                            </label>
                             
                            <input
                              type="text"
                              className={
                                fileNumber.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="File number"
                              name={fileNumber.name}
                              value={fileNumber.value}
                              onChange={this.onChange}
                              onBlur={this.onBlur}
                            />
                             
                            { isFileNumberValid === false && (
                              <small className="text-danger">
                                A file with similar number already exists
                              </small>
                            
                             )}
                             
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              Dated <small className="text-danger">*</small>
                            </label>
                            <input
                              type="date"
                              className={
                                dated.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Name of the employee"
                              name={dated.name}
                              value={dated.value}
                              onChange={this.onChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>
                              Subject <small className="text-danger">*</small>
                            </label>
                            <input
                              type="text"
                              className={
                                subject.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Subject"
                              name={subject.name}
                              value={subject.value}
                              onChange={this.onChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>
                              Financial implication{" "}
                              <small className="text-danger">*</small>
                            </label>
                            <NumberFormat
                              decimalScale={2}
                              thousandSeparator={true}
                              allowNegative={false}
                              className={
                                financialImplication.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Must be greater than or equal to zero"
                              name={financialImplication.name}
                              value={financialImplication.value}
                              onValueChange={(e: any) => {
                                this.onChange({
                                  target: {
                                    name: financialImplication.name,
                                    value: e.value,
                                  },
                                });
                              }}
                            />
                          </div>
                        </div>




 
                        {/*  
                        approving authority 
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>
                              Approving authority {" "}
                              <small className="text-danger">*</small>
                            </label>
                       
                            <select
                              className={
                                approvingAuthority.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              name={approvingAuthority.name}
                              value={approvingAuthority.value}
                              onChange={this.onChange}
                            >
                              <option>Select a Approver</option>
                              {approvingAuthority.options.map(function (
                                item: any,
                                index: number
                              ) {
                                return (
                                  <option key={index} value={item.code}>
                                    {item.name} - {item.employeeNumber}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
 */}




                        <div className="col-md-12">
                          <div className="form-group">
                            <label>
                              Proposal <small className="text-danger">*</small>
                            </label>
                            <TextEditor
                              error={body.error}
                              name={body.name}
                              value={body.value}
                              onChange={this.onChange}
                              placeholder="Please elaborate the details of requirement, justification."
                            />
                          </div>
                        </div>


{/* 

                        <div className="col-md-12">
                          <div className="form-group">
                            <label>
                              Recipient <small className="text-danger">*</small>
                            </label>
                            <Typeahead
                              id="ta-recipient"
                              flip={true}
                              multiple={true}
                              labelKey={(option: any) =>
                                `${option.name} - ${option.employeeNumber}`
                              }
                              name={to.name}
                              value={to.value}
                              options={to.options}
                              onChange={(e: any) =>
                                this.typeaheadOnChange(to.name, e)
                              }
                              placeholder="Send to"
                              isInvalid={to.error.length > 0}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>
                              Department{" "}
                              <small className="text-danger">*</small>
                            </label>

                            <Typeahead
                              id="ta-department"
                              dropup={true}
                              labelKey="name"
                              name={department.name}
                              value={department.value}
                              multiple={true}
                              options={department.options}
                              onChange={(e: any) =>
                                this.typeaheadOnChange(department.name, e)
                              }
                              placeholder="Specify the order of department in which the file should ideally move"
                              isInvalid={to.error.length > 0}
                            />
                             
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>
                              File(s) <small className="text-danger">*</small>
                            </label>
                             
                            {department.value.length ? (
                              < div className="alignFile" > <input
                                name={attachments.name}
                                onChange={this.onChange}
                                className={
                                  attachments.error.length > 0
                                    ? "form-control is-invalid"
                                    : "form-control  "
                                }
                                type="file"
                                multiple={true}
                                style={{ padding: 4 }}
                              />
                              <div className="attachedFIle">
                                  
                              {attachments.value.length!=0?attachments.value.length:"" }
                               </div>
                              </div>
                            ) : (
                              <p>
                                Please select department before uploading files
                              </p>
                            )}
                          </div>
                          <div
                             className="mb-3">
                         
                            {Array.from(attachments.value).map(function (
                              item: any,
                              index: number,
                              array: any
                            ) {
                              return (
                                < >
                                
                                  <span
                                    key={index}
                                    className="badge badge-primary mr-1 dlt_file " >
                                    {item.name}
                                    <i onClick={e=>dltFile.dltItem(index,array)}  className="fa fa-times "
                                    style={{ color: "red" }} aria-hidden="true" />
                                  </span>  
                                </>
                              );
                            })}
                             
                          </div>
                        </div>
                        <div className="col-md-12">
                          <p>Add References</p>
                          <div className="form-group">
                            <label>
                              Select Department <small>(Optional)</small>
                            </label>

                            <Typeahead
                              id="ta-department"
                              dropup={true}
                              labelKey="name"
                              name={referenceFilesDept.name}   
                              value={referenceFilesDept.value}    
                              options={referenceFilesDept.options}     
                              onChange={this.onDeptSelectForReference}
                              placeholder="Select Department to select respective files for reference"
                              isInvalid={referenceFilesDept.error.length > 0}
                            />
                          </div>


                          {referenceFiles.options.length ? (
                            <div className="form-group">
                              <label>
                                Select Files <small>(Optional)</small>
                              </label>
                               
                              <SearchBox
                                style={{
                                  marginTop: "5px",
                                  marginBottom: "5px",
                                }}
                                placeholder=" Search Files using File Number "
                                onSearch={(newValue) => {
                                    getfilesByFileCode(newValue).then((response:any)=>{
                                        setOptions(this,this.state.referenceFiles.name,response.result) 
                                    }).catch((err:any)=>{
                                    })
                                  }
   
                                }
                              />
                              <div
                                style={{
                                  maxHeight: "300px",
                                  overflow: "auto",
                                  marginTop: "5px",
                                  marginBottom: "5px",
                                }}
                              >
                                {referenceFiles.options.map((item: any) => (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      onInput={(_) =>
                                        this.onSelectingReferenceFiles(item)
                                      }
                                    />
                                    <p
                                      style={{ margin: 0, marginLeft: "5px" }}
                                      key={item.fileName}
                                     >
                                      {item.originalFileName}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : "" }
                        </div> */}





                        <div className="col-md-6">
                          <Link
                            to={CONSTANT.component.userFileList.url}
                            className="btn btn-block cancel-button btn-sm btn-sm"
                          >
                            Cancel
                          </Link>
                        </div>
                         
                        {/* <div className="col-md-6">
                                                <button type="submit" className="btn btn-block submit-button btn-sm" onClick={this.HandleDraft}>Save as Draft</button>
                                                </div> */}
                        <div className="col-md-6">
                          
                           <button
                            type="submit"
                            className="btn btn-block submit-button btn-sm"
                          >
                            Re-initiate
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showLoader && <Loader />}

        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            />
            {/* Same as */}
            <ToastContainer />
            
      </div>
    );
  }

  dltItem = (index: any ,array:any) => {    
    let finalArray=array.splice(index,1)
    setValue( this, this.state.attachments.name, array )  
  
  }

 
  onChange = (e: any) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === this.state.attachments.name) {
        value = e.target.files;
    }
    if (name === this.state.body.name) {
      setStorage("propsal", value);
    }
    onChange(this, name, value);
  };

   
  onBlur = (e: any) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === this.state.fileNumber.name) {
     
    checkFileNumber(value).then((res: any) => {
     
       this.setState({
          isFileNumberValid: true,
        });
      });
     }


  };

  onDeptSelectForReference = async (dept: any) => {

    if (dept.length) {
      const { code } = dept[0];
      const fileList = await getFileListDeptWise(code);
      
      setOptions( this, this.state.referenceFiles.name, fileList.result );
    }
     
  };

  onSelectingReferenceFiles = (file: any) => {
     
    this.state.referenceFiles.value.push({
      fileName: file.fileName,
      originalFileName: file.originalFileName,
      fileCode: file.fileCode,
    });
    this.setState({
      ...this.state,
      referenceFiles: { ...this.state.referenceFiles },
    });
      
   };

  typeaheadOnChange = (name: string, e: any) => {
    let value = e;
    if (e.length > 0 && e[0].customOption) {
      value = [{ name: e[0].name }];
    }
    if (name === "to" || name === "referenceFiles") {
      onArrayChange(this, name, value);
    } else {
      onChange(this, name, value);
    }
    onChange(this, name, value);
  };


  
  onSubmit = (e: any) => {

    e.preventDefault();

 const {userDetail:{isHOD} , to ,fileCode ,fileNumber } = this.state
   
    // 3963, 2111,116 these all are CMD , only HOD can add CMD
    let formData = {
       state :{
        fileNumber:{...this.state.fileNumber} ,
        Dated:{...this.state.Dated},
        subject:{...this.state.subject},
        financialImplication:{...this.state.financialImplication},
        Proposal:{...this.state.body} 
       }
    }
    if(to.value.some((ele:any) => ele.employeeNumber==3963 || ele.employeeNumber==2111 || ele.employeeNumber==116 )) {
      if(!isHOD) {
        toast.error('You are not authorised user to forward files to CMD ', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light" ,
            });
        return 
      }   
     }

    if (
      
      // validateForm(formData) &&
      // this.state.isFileNumberValid &&
      !this.state.showLoader
       )
         
    {
      this.setState({ showLoader: true });
      // const st = this.state;

      // const model = {
      //   fileNumber: st.fileNumber.value ,
      //   dated: st.dated.value ,
      //   subject: st.subject.value ,
      //   body: st.body.value ,
      //   to: st.to.value ,
      //   financialImplication: st.financialImplication.value,
      //   approvingAuthority: [st.approvingAuthority.value],
      //   department: st.department.value,
      //   referenceFiles: st.referenceFiles.value,
      // };

      reintiateParkedFile(fileCode , {
        fileNumber:fileNumber.value
      } ).then((res:any)=>{
                 if(res.status === CONSTANT.static.apiStatus.success) {
                   this.setState({ showLoader: false } ,()=>{
                    toast.success(' file reintiated ', {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                      });
                       
                      this.props.history.push(constant.component.userFileList.url)

                   });
                 }
      }).catch((err:any)=>{
        console.log(err)
        this.setState({ showLoader: false });
         
      })
       
      // addFile(model).then(async (res: any) => {
      //   if (res.status === CONSTANT.static.apiStatus.success) {
      //     for (let j = 0; j < st.department.value.length; j++) {
      //       for (let i = 0; i < st.attachments.value.length; i++) {
      //         const item = st.attachments.value[i];
      //         
      //         const itemModel = {
      //           fileCode: res.result.code,
      //           deptCode: st.department.value[j].code,
      //           attachment: item,
      //         };
      //         await uploadAttachment(itemModel);
      //       }
      //     }
      //     this.setState({ showLoader: false });
      //     setStorage("propsal", "");
      //     this.props.history.push(CONSTANT.component.userFileList.url);
      //   } else {
      //     this.setState({ showLoader: false });
      //     alert(res.error);
      //   }
      // });
    }



    
  };
 

  HandleDraft = (e: any) => {
    const isSure = window.confirm("Are you sure, you want to Save this?");
    if (isSure) {
      const id = parseInt(e.target.dataset.id, 10);
      autoSave(id).then((res: any) => {
        if (res.status === CONSTANT.static.apiStatus.success) {
          window.location.reload();
        } else {
          alert(res.error.message);
        }
      });
    }
  };
}



export default IntitateParkedFile;




